import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Clock } from "lucide-react";

const TimeEntriesCard = ({ timeEntries = [], formatDate }) => {
  return (
    <Card data-testid="time-entries-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-rnb-blue" />
          Time Entries
        </CardTitle>
      </CardHeader>
      <CardContent>
        {timeEntries.length > 0 ? (
          <div className="space-y-3">
            {timeEntries.map((entry) => (
              <div
                key={entry.entry_id}
                className="flex items-center justify-between p-4 bg-slate-50 rounded-lg"
                data-testid={`time-entry-${entry.entry_id}`}
              >
                <div>
                  <p className="font-medium text-rnb-navy">{entry.description}</p>
                  <p className="text-sm text-rnb-gray">{formatDate(entry.date)}</p>
                </div>
                <p className="font-mono-numbers font-semibold text-rnb-blue">
                  {entry.hours}h
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-rnb-gray py-8">No time entries</p>
        )}
      </CardContent>
    </Card>
  );
};

export default TimeEntriesCard;
